var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"n-teacher__photo"},[_c('div',{staticClass:"n-teacher__photo-wrapper"},[_c('div',{staticClass:"n-teacher__photo-pic",class:{ '_no-avatar': _vm.noAvatar },style:(("background-image: url('" + _vm.photoUrl + "')"))})])])}
var staticRenderFns = []

export { render, staticRenderFns }